export default "__VITE_ASSET__12737788__"